import { createTheme } from "@dash/default-theme";
import { Theme, ThemeProvider } from "@emotion/react";
import { NewRouterBreadcrumbsBar } from "@legacy-megarax/ui-components";
import { useConfig } from "@megarax/dev-config";
import { MegaraxWebappContainer } from "@megarax/features";
import { BudgetPage, BudgetsHome, NewBudgetPage } from "@megarax/invoices-budgets";
import {
  AllDraftsPage,
  AllThreadsHome,
  CreateDraftPage,
  DraftPage,
  MyThreadsRedirect,
  ThreadPage,
  ThreadStateContextProvider,
} from "@megarax/invoices-invoice-thread";
import { MegaraxProviders } from "@megarax/root";
import { MdRequestQuote } from "react-icons/md";
import { Outlet, Route } from "react-router-dom-v5-compat";

const invoicesTheme: Theme = createTheme("234");

export const useInvoicesRouter = () => {
  return (
    <Route
      path="/faktury"
      element={
        <ThemeProvider theme={invoicesTheme}>
          <InvoicesMegaraxWebappContainer />
        </ThemeProvider>
      }
    >
      <Route path="wersje-robocze">
        <Route path="" element={<AllDraftsPage />} />
        <Route path="nowa" element={<CreateDraftPage />} />
        <Route path=":uuid/*" element={<DraftPage />} />
      </Route>
      <Route path="watki">
        <Route path="" element={<AllThreadsHome />} />
        <Route path="moje-faktury" element={<MyThreadsRedirect />} />
        <Route path="moje_faktury" element={<MyThreadsRedirect />} />
        <Route path=":uuid/*" element={<ThreadPage />} />
      </Route>
      <Route path="budzety">
        <Route path="" element={<BudgetsHome />} />
        <Route path=":uuid" element={<BudgetPage />} />
        <Route path="nowy" element={<NewBudgetPage />} />
      </Route>
    </Route>
  );
};

const InvoicesMegaraxWebappContainer: React.FC = () => {
  const { config } = useConfig();

  return (
    <MegaraxWebappContainer
      logo={<MdRequestQuote width="1em" height="1em" />}
      title="Faktury"
      subtitle="megarax.net"
      bypassAuth={config.testUser.enabled}
    >
      <ThreadStateContextProvider>
        <MegaraxProviders themeConfig="invoices">
          <NewRouterBreadcrumbsBar />
          <Outlet />
        </MegaraxProviders>
      </ThreadStateContextProvider>
    </MegaraxWebappContainer>
  );
};
